import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@domain-group/suit-theme'

import useTeam from '@hooks/useTeam'

import { confirmDelete } from '@functions/entity'

interface TeamToolsProps {
  teamPayload: ReturnType<typeof useTeam>,
}

const TeamTools = (props: TeamToolsProps) => {
  const {
    teamPayload: {
      callbacks: {
        deleteTeam: deleteFn,
      },
      deleting,
    },
  } = props

  const confirmDeletePayload = {
    callbacks: { deleteFn },
    options: { shouldRedirect: true },
    strings: { entityName: 'Team' },
  }

  return (
    <Tools>
      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faTrashAlt} />}
        loading={deleting}
        onClick={() => confirmDelete(confirmDeletePayload)}
        size="medium"
      >
        Delete Team
      </Button>
    </Tools>
  )
}

export default TeamTools
